import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { appServices } from '@/data/AppServices';

export function SentenceListPage() {
  const [queue, setQueue] = useState({ newCount: 0, reviewCount: 0, totalCount: 0 });
  const navigate = useNavigate();

  const reload = useCallback(async () => {
    setQueue(await appServices.sentences.todayQueue());
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return (
    <div className="page stack">
      <section className="card stack">
        <strong>例句练习</strong>
        <div className="muted">先想整句销售表达，再对照参考英文。补上词汇和情景之间的那一层。</div>
        <div className="muted">
          可练 {queue.totalCount} 条 · 新 {queue.newCount} · 到期 {queue.reviewCount}
        </div>
        <button type="button" onClick={() => navigate('/scenario/sentences/practice')}>
          开始例句练习
        </button>
      </section>
    </div>
  );
}
